module.exports = __webpack_public_path__ + "img/qilin-f-stage5.94c62093.png";